import {STORAGE_ROOT} from 'constants/routes';
import {format} from 'date-fns';
import {useModal} from 'extensions/viewport/useModal';
import {useEffect, useState} from 'react';
import useShareActions, {
  UpdateMode,
} from '../dialogs/SharedCustomizeDialog/hooks/useShareActions';
import {SharedShareDialog} from '../dialogs/SharedShareDialog';

interface CreateAutoShareProps {
  workspaceFolderName: string;
}

export function useCreateAutoShare({
  workspaceFolderName,
}: CreateAutoShareProps) {
  const modal = useModal();

  const [callCreateShare, setCallCreateShare] = useState(false);
  const [items, setItems] = useState<string[]>([]);

  const {
    shareState: {setTitle},
    handleCreateShare,
  } = useShareActions({
    workspaceFolderName,
    folderParentId: STORAGE_ROOT,
    updateMode: UpdateMode.Create,
    items,
  });

  const createAutoShare = (selectedItems: string[]) => {
    setItems(selectedItems ?? []);
    setTitle(`${format(new Date(), 'MMM d, yyyy, hh:mm a')}`);
    setCallCreateShare(true);
  };

  const createShareAndOpenDialog = async () => {
    try {
      modal.open(
        <SharedShareDialog
          workspaceFolderName={workspaceFolderName}
          fetchShareDetails={handleCreateShare}
          done={modal.close}
        />,
      );
    } finally {
      setCallCreateShare(false);
    }
  };

  useEffect(() => {
    if (callCreateShare) {
      createShareAndOpenDialog();
    }
  }, [callCreateShare]);

  return {createAutoShare};
}
